<template>
  <label :class="cssClass">
    <input
      type="checkbox"
      class="c-btn--toggle__check"
      :checked="checked"
      :disabled="disabled"
      @change="change"
    />
    <span
      v-for="item in items"
      class="c-btn--toggle__item"
      :key="item.value"
      :style="cssStyle"
      ref="item"
    >
      {{ item.label }}
    </span>
  </label>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    disabled: {
      type: Boolean,
      required: false
    },
    items: {
      type: Array,
      required: false,
      default() {
        return [
          {
            label: 'ON',
            value: true
          },
          {
            label: 'OFF',
            value: false
          }
        ];
      }
    },
    value: {
      type: [Boolean, String],
      required: true
    }
  },
  data() {
    return {
      width: null
    };
  },
  computed: {
    checked() {
      return this.items.findIndex(item => item.value === this.value) === 0;
    },
    cssClass() {
      return {
        'c-btn': true,
        'c-btn--toggle': true,
        'is-checked': this.checked,
        'is-disabled': this.disabled,
        'is-off': !this.value
      };
    },
    cssStyle() {
      return {
        width: this.width ? this.width + 'px' : null
      };
    }
  },
  watch: {
    items: {
      handler() {
        this.setWidth();
      },
      immediate: true
    }
  },
  methods: {
    change(e) {
      const index = e.target.checked ? 0 : 1;
      const item = this.items[index];
      this.$emit('change', item.value);
    },
    setWidth() {
      this.width = null;
      this.$nextTick(() => {
        if (this.$refs.item) {
          const widths = this.$refs.item.map(item => {
            return item.getBoundingClientRect().width;
          });
          // 左右の幅を大きい方の幅に揃える
          this.width = Math.round(Math.max(...widths));
        }
      });
    }
  }
};
</script>
